// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeOutUp {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(0, -5rem, 0);
  }
}

.fadeOutUp {
  animation-name: fadeOutUp;
}
`, "",{"version":3,"sources":["webpack://./resources/assets/js/scss/custom-animate/fading_exits/fadeOutUp.css"],"names":[],"mappings":"AAAA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,mCAAmC;EACrC;AACF;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["@keyframes fadeOutUp {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, -5rem, 0);\n  }\n}\n\n.fadeOutUp {\n  animation-name: fadeOutUp;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
